<template>
  <nav class="desktop-navbar">
    <div class="navbar-container">
      <!-- Logo Section -->
      <div class="navbar-brand">
        <router-link to="/" class="brand-link">
          <img
            src="/img/saludsa_logo_horizontal.png"
            alt="Saludsa"
            class="navbar-logo"
          />
        </router-link>
      </div>

      <!-- Navigation Menu -->
      <div class="navbar-nav">
        <router-link
          to="/"
          class="nav-link"
          :class="{ active: $route.path === '/' }"
        >
          <i class="fas fa-home nav-icon"></i>
          <span class="nav-text">Inicio</span>
        </router-link>

        <router-link
          to="/referidos"
          class="nav-link"
          :class="{ active: $route.path === '/referidos' }"
        >
          <i class="fas fa-users nav-icon"></i>
          <span class="nav-text">Referidos</span>
        </router-link>

        <router-link
          to="/transactions"
          class="nav-link"
          :class="{ active: $route.path === '/transactions' }"
        >
          <i class="fas fa-exchange-alt nav-icon"></i>
          <span class="nav-text">Transacciones</span>
        </router-link>

        <router-link
          to="/bank-account"
          class="nav-link"
          :class="{ active: $route.path === '/bank-account' }"
        >
          <i class="fas fa-university nav-icon"></i>
          <span class="nav-text">Cuenta Bancaria</span>
        </router-link>
      </div>

      <!-- User Section -->
      <div class="navbar-user">
        <div class="user-info" v-if="user">
          <div class="user-avatar">
            <i class="fas fa-user"></i>
          </div>
          <div class="user-details">
            <div class="user-name">
              {{ user.displayName || user.userId || "Usuario" }}
            </div>
            <div class="user-email">{{ user.email || "" }}</div>
          </div>
        </div>

        <!-- User Dropdown -->
        <div class="user-dropdown">
          <button
            @click.stop="toggleDropdown"
            class="dropdown-toggle"
            :class="{ active: showDropdown }"
            type="button"
          >
            <i class="fas fa-chevron-down"></i>
          </button>

          <div
            v-show="showDropdown"
            class="dropdown-menu"
            @click.stop
            style="display: block !important"
          >
            <div class="dropdown-header">
              <div class="user-info-small">
                <div class="user-avatar-small">
                  <i class="fas fa-user"></i>
                </div>
                <div class="user-details-small">
                  <div class="user-name-small">
                    {{ user?.displayName || user?.userId || "Usuario" }}
                  </div>
                  <div class="user-email-small">{{ user?.email || "" }}</div>
                </div>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <router-link
              to="/privacy"
              class="dropdown-item"
              @click="closeDropdown"
            >
              <i class="fas fa-shield-alt"></i>
              Política de Privacidad
            </router-link>
            <router-link
              to="/terms"
              class="dropdown-item"
              @click="closeDropdown"
            >
              <i class="fas fa-file-contract"></i>
              Términos y Condiciones
            </router-link>
            <div class="dropdown-divider"></div>
            <button @click="handleLogout" class="dropdown-item logout-item">
              <i class="fas fa-sign-out-alt"></i>
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DesktopNavbar",
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["logout"]),

    toggleDropdown() {
      console.log("Toggle dropdown clicked, current state:", this.showDropdown);
      this.showDropdown = !this.showDropdown;
      console.log("New dropdown state:", this.showDropdown);
    },

    closeDropdown() {
      this.showDropdown = false;
    },

    handleLogout() {
      // Set logout flag before clearing authentication
      sessionStorage.setItem("wasLoggedOut", "true");
      this.logout();
      this.$router.push("/login");
      this.closeDropdown();
    },
  },
  mounted() {
    // Close dropdown when clicking outside
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
};
</script>

<style scoped>
.desktop-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: white;
  border-bottom: 1px solid #e9ecef;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  display: none;
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.navbar-brand {
  flex-shrink: 0;
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.navbar-logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.navbar-nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex: 1;
  justify-content: center;
  flex-wrap: nowrap;
}

.nav-link {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: #6c757d;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.9rem;
  white-space: nowrap;
  flex-shrink: 0;
}

.nav-link:hover {
  background-color: #f8f9fa;
  color: #0c75ba;
  transform: translateY(-1px);
}

.nav-link.active {
  background-color: #0c75ba;
  color: white;
  box-shadow: 0 2px 8px rgba(12, 117, 186, 0.3);
}

.nav-icon {
  font-size: 1rem;
  width: 16px;
  text-align: center;
}

.nav-text {
  font-size: 0.9rem;
}

.navbar-user {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: #e9ecef;
}

.user-avatar {
  width: 35px;
  height: 35px;
  background: #0c75ba;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.9rem;
}

.user-details {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.user-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.user-email {
  font-size: 0.8rem;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.user-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dropdown-toggle:hover {
  background: #f8f9fa;
  color: #0c75ba;
}

.dropdown-toggle.active {
  background: #0c75ba;
  color: white;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 250px;
  z-index: 9999;
  margin-top: 5px;
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  transition: all 0.3s ease;
}

.dropdown-header {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.user-info-small {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar-small {
  width: 30px;
  height: 30px;
  background: #0c75ba;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.8rem;
}

.user-details-small {
  flex: 1;
  min-width: 0;
}

.user-name-small {
  font-weight: 600;
  font-size: 0.9rem;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email-small {
  font-size: 0.8rem;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-divider {
  height: 1px;
  background: #e9ecef;
  margin: 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 15px;
  background: none;
  border: none;
  color: #6c757d;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  text-align: left;
  border-radius: 0;
}

.dropdown-item:hover {
  background: #f8f9fa;
  color: #0c75ba;
  text-decoration: none;
}

.logout-item {
  color: #dc3545;
}

.logout-item:hover {
  background: #f8d7da;
  color: #721c24;
}

/* Show navbar only on desktop */
@media (min-width: 1024px) {
  .desktop-navbar {
    display: block;
  }

  /* Force horizontal layout */
  .navbar-nav {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
  }

  .nav-link {
    display: flex !important;
    flex-direction: row !important;
    white-space: nowrap !important;
  }
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .navbar-container {
    padding: 0 15px;
  }

  .nav-text {
    display: none;
  }

  .nav-link {
    padding: 10px 12px;
  }

  .user-name,
  .user-email {
    max-width: 100px;
  }
}

@media (max-width: 1100px) {
  .user-details {
    display: none;
  }

  .user-info {
    padding: 8px;
  }
}
</style>
